__turbopack_context__.v({
  "avatar": "IssueCard-module__Yt7p0G__avatar",
  "dimmed": "IssueCard-module__Yt7p0G__dimmed",
  "menuContainer": "IssueCard-module__Yt7p0G__menuContainer",
  "topic": "IssueCard-module__Yt7p0G__topic",
  "topicContainer": "IssueCard-module__Yt7p0G__topicContainer",
});
